"use client";
import React, { useEffect, useState } from "react";
import Topfooter from "@/components/FooterComponent/Topfooter";
import ProgramList from "@/components/FooterComponent/ProgramList";
import Newsletter from "@/components/FooterComponent/Newsletter";
import ContactWithCopyright from "@/components/FooterComponent/ContactWithCopyright";
import {
  RiLinkedinFill,
  RiFacebookFill,
  RiTwitterXFill,
  RiInstagramFill,
  RiYoutubeFill,
} from "@remixicon/react";

const ServerUrl = process.env.NEXT_PUBLIC_SERVER_URL;

export default function Footer({ serverMenuData, serverFooterOptions }) {

  const [footerMenuData, setFooterMenuData] = useState(serverMenuData || null);
  const [footerOptions, setFooterOptions] = useState(
    serverFooterOptions || null,
  );

  // Fetch all menus if not provided by server
  useEffect(() => {
    if (serverMenuData) return;
    const fetchFooterData = async () => {
      try {
        const response = await fetch(`${ServerUrl}/tree-menus/menu`);
        const data = await response.json();
        setFooterMenuData(data);
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };

    fetchFooterData();
  }, [serverMenuData]);

  // Find the "Footer About" menu from API
  const aboutMenu = footerMenuData?.data?.find(
    (menu) => menu.slug === "footer-about",
  );

  // Map API items -> { name, slug } for Topfooter
  const aboutLinks =
    aboutMenu?.items?.map((item) => ({
      // adjust field names here if your item shape is different
      name: item.title,
      slug: item.slug ?? item.url ?? "#",
    })) ?? [];

  const academicsMenu = footerMenuData?.data?.find(
    (menu) => menu.slug === "footer-academics",
  );

  const academicsLinks =
    academicsMenu?.items?.map((item) => ({
      name: item.title,
      slug: item.slug ?? item.url ?? "#",
    })) ?? [];

  // Admission Menu
  const admissionMenu = footerMenuData?.data?.find(
    (menu) => menu.slug === "footer-admission",
  );
  const admissionLinks =
    admissionMenu?.items?.map((item) => ({
      name: item.title,
      slug: item.slug ?? item.url ?? "#",
    })) ?? [];

  // Disclosure Menu
  const disclosureMenu = footerMenuData?.data?.find(
    (menu) => menu.slug === "footer-disclosure",
  );
  const disclosureLinks =
    disclosureMenu?.items?.map((item) => ({
      name: item.title,
      slug: item.slug ?? item.url ?? "#",
    })) ?? [];

  // Quick Links Menu
  const quickMenu = footerMenuData?.data?.find(
    (menu) => menu.slug === "footer-quick-links",
  );

  const quickLinks =
    quickMenu?.items?.map((item) => ({
      name: item.title,
      slug: item.slug ?? item.url ?? "#",
    })) ?? [];

  useEffect(() => {
    if (serverFooterOptions) return;
    const fetchFooterOptions = async () => {
      try {
        const response = await fetch(
          `${ServerUrl}/footer?populate[SchoolDetails][populate]=SchoolCourses`,
        );
        const data = await response.json();
        setFooterOptions(data);
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };

    fetchFooterOptions();
  }, [serverFooterOptions]);

  // Footer Description from footer options
  const footerDescription = footerOptions?.data?.Description || "";
  const footerCopyright = footerOptions?.data?.CopyrightText || "";
  const footerAddress = footerOptions?.data?.Address || "";
  const footerMobile = footerOptions?.data?.Mobile || "";
  const footerEmail = footerOptions?.data?.Email || "";
  const footerFacebook = footerOptions?.data?.Facebook || "";
  const footerLinkedin = footerOptions?.data?.Linkedin || "";
  const footerX = footerOptions?.data?.X || "";
  const footerInstagram = footerOptions?.data?.Instagram || "";
  const footerYoutube = footerOptions?.data?.Youtube || "";
  const footerNewsletterText = footerOptions?.data?.NewsletterText || "";
  const footerSchoolCourses = footerOptions?.data?.SchoolDetails || [];

  const programsData =
    footerSchoolCourses.map((school) => ({
      title: school.Title,
      url: school.School_URL,
      programs: school.SchoolCourses.map((course) => ({
        name: course.Title,
        slug: course.SchoolURL,
      })),
    })) || [];

  const footerData = {
    socialLinks: [
      {
        Icon: RiLinkedinFill,
        label: "LinkedIn",
        url: footerLinkedin || "#",
      },
      {
        Icon: RiFacebookFill,
        label: "Facebook",
        url: footerFacebook || "#",
      },
      {
        Icon: RiTwitterXFill,
        label: "X",
        url: footerX || "#",
      },
      {
        Icon: RiInstagramFill,
        label: "Instagram",
        url: footerInstagram || "#",
      },
      {
        Icon: RiYoutubeFill,
        label: "YouTube",
        url: footerYoutube || "#",
      },
    ],

    footerMenus: [
      {
        title: "About",
        links: aboutLinks,
      },

      {
        title: "Academics",
        links: academicsLinks,
      },

      {
        title: "Admissions",
        links: admissionLinks,
      },
      {
        title: "Disclosure",
        links: disclosureLinks,
      },
      {
        title: "Quick Links",
        links: quickLinks,
      },
    ],
  };

  return (
    <footer className="bg-[#081E2D] text-white  mx-auto pt-4 md:pt-16">
      <Topfooter
        footerData={footerData}
        footerDescription={footerDescription}
      />
      <hr className="border-white/10" />
      <ProgramList programsData={programsData} />
      <Newsletter footerNewsletterText={footerNewsletterText} />
      <ContactWithCopyright
        footerData={footerData}
        footerCopyright={footerCopyright}
        footerAddress={footerAddress}
        footerMobile={footerMobile}
        footerEmail={footerEmail}
      />
    </footer>
  );
}
